module.exports = __webpack_public_path__ + "static/34-663f64d2bb12a1c5f99c10208be4a99c.jpg";